import { validateFloods } from '../../helpers/validators'
import type { CalculationColumn } from '../../types/column-types'
import { renderCalcPos } from '../../helpers/helpers'
import Floods from '../../../../components/editable-cell/form-items/floods'
import { DataSourceItem } from '../../helpers/convert-calculations-to-data-source'
import isCalculation from '../../helpers/is-calculation'

export const stampFloodsColumn: CalculationColumn = {
    dataIndex: 'stampFloods',
    title: 'Р',
    width: 30,
    editable: true,
    FormItem: <Floods />,
    validator: validateFloods,
    render: renderCalcPos((r, v) =>
        r.withoutCutting ? r.virtualStamp?.floods : r.stampFloods || r.stamp?.floods || ''
    ),
    onCell: (record: DataSourceItem) => {
        if (isCalculation(record)) {
            return { colSpan: 0 }
        }
        return {
            colSpan: 1,
            editable: !record.withoutCutting,
        }
    },
}
